import React, { useEffect } from "react";

const Dialog = ({ children }) => {

    useEffect(() => {
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "unset";
        }
    }, []);

    return (
        <div className="fixed top-0 left-0 w-screen h-screen z-[1001] bg-black bg-opacity-70 flex items-center justify-center">
            <div className="bg-[#212529] border-white rounded-xl p-8 max-w-[80vw]">
                {children}
            </div>
        </div>
    );
}

export default Dialog;